import { Exclude, Expose } from "class-transformer"

@Exclude()
export class ProductVariantSearch {

  @Expose()
  public serviceCode!: number

  @Expose()
  public serviceBackCode!: number

  @Expose()
  public asCode?: string

}
